import { postAsJson } from "./AbstractService";
import { ConstantesApi } from "@common/utils";

export const  getCompetitorHealth = async ({ product, storeId, competitorIds }) => {
    const params = {
        api: ConstantesApi.API_METRICS,
        data: {
            product,
            storeId,
            competitorIds,
        },
        skipDispatch: true
    };
    
    try {
        const response = await postAsJson(params);
        return response;
    } catch (error) {
        console.error('Error loading competitor health metrics:', error);
        return { competitors: [] };
    }
};